import React, { useEffect } from 'react';
import { getConfig } from '../actions/config';
import { connect } from 'react-redux';

const Messages = ({ config, getConfig }: any) => {
  useEffect(() => {
    getConfig();
  }, []);

  return (
    config.homePageMessage.trim() !== '' && (
      <div className=" container">
        <div className=" text-left text-danger">
          <h5
            className="text-left mt-4 px-2 mb-0 font-weight-bold"
            style={{
              whiteSpace: 'pre-wrap',
            }}
          >
            {config.homePageMessage}
          </h5>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state: any) => ({
  config: state.config,
});

export default connect(mapStateToProps, { getConfig })(Messages);
